//      
                                              
             
             
                     
                     
                        
                 
             
                        
import whenCombining from './when-combining';
import whenReordering from './when-reordering';
import withDroppableDisplacement from '../../with-scroll-change/with-droppable-displacement';

              
                     
                            
                                
                                 
                                    
   

const getResultWithoutDroppableDisplacement = ({
  impact,
  draggable,
  droppable,
  draggables,
  afterCritical,
}      )           => {
  const original           = draggable.page.borderBox.center;
  const at                  = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact,
      draggable,
      draggables,
      droppable,
      afterCritical,
    });
  }

  return whenCombining({
    impact,
    draggables,
    afterCritical,
  });
};

export default (args      )           => {
  const withoutDisplacement           = getResultWithoutDroppableDisplacement(
    args,
  );

  const droppable                      = args.droppable;

  const withDisplacement           = droppable
    ? withDroppableDisplacement(droppable, withoutDisplacement)
    : withoutDisplacement;

  return withDisplacement;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-center-from-impact/get-page-border-box-center/index.js